export enum DiscountUsage {
	Once = 1,
	Multiple = 2,
}
